import React from 'react';
import { translate } from 'react-i18next';
import * as Common from 'common/components';

const UsersTable = ({
  children,
  count = 0,
  isLoading,
  company,
  subcompany,
  permissions,
  handleToggle = () => {},
  t = (key) => key,
  order,
  orderBy,
  handleOrderChange,
}) => {
  const headers = [
    { variable: 'name', text: t('users.fields.name') + ': ', type: 'h3' },
    { variable: 'lastname', text: t('users.fields.lastname') + ': ' },
    { variable: 'email', text: t('users.fields.email') + ': ' },
    {
      variable: 'active',
      text: t('common.active', { context: 'male' }) + ': ',
      boolean: true,
    },
    //user.company.role.name
    {
      variable: 'company.role.name',
      // parent: "company",
      pathVariable: 'company.role.name',
      text: t('users.fields.roleId') + ': ',
    },
  ];

  const config = {
    actions: t('common.actions'), //Texto de seccion de acciones
    edit: t('common.edit'), //Texto de boton editar
    editPermission: 'acl.users.update',
    togglePermission: 'acl.users.toggle',
    editUrl: 'users', //Url para editar empleado
    propsName: 'user', //de donde se obtienen los props
    company: company,
    subcompany: subcompany,
  };

  const dataCard = {
    rows: children,
    headers: headers,
    config: config,
    permissions: permissions,
    handleClick: handleToggle,
  };

  console.log(dataCard);

  return (
    <div className="table-responsive" style={{ position: 'relative' }}>
      <Common.List dataCard={dataCard}>
        {/* <table className="table table-hover table-striped"> */}
        <thead>
          <tr>
            <Common.ThSortable
              orderBy={orderBy}
              order={order}
              field="name"
              handleOrderChange={handleOrderChange}
            >
              {t('users.fields.name')}
            </Common.ThSortable>
            <Common.ThSortable
              orderBy={orderBy}
              order={order}
              field="lastname"
              handleOrderChange={handleOrderChange}
            >
              {t('users.fields.lastname')}
            </Common.ThSortable>
            <Common.ThSortable
              orderBy={orderBy}
              order={order}
              field="email"
              handleOrderChange={handleOrderChange}
            >
              {t('users.fields.email')}
            </Common.ThSortable>
            <th className="text-center">{t('common.active', { context: 'male' })}</th>
            <th className={'text-center'}>{t('users.fields.roleId')}</th>
            <th className="text-center">{t('common.actions')}</th>
          </tr>
        </thead>
        <tbody>
          {!count && <Common.EmptyTable colSpan={6} />}
          {children}
        </tbody>
      </Common.List>
      {/* </table> */}
      <Common.LoaderOverlay show={isLoading} />
    </div>
  );
};

export default translate()(UsersTable);



// WEBPACK FOOTER //
// src/modules/secured/modules/notifications_historic/components/form/sections/NotificationHistoricFormUsersTable.js